<template>
    <div class="flex items-start" :class="[{
          'flex-row-reverse' : (chat.type === 0 || type === 'customer-agent') && !chat.is_log_message,
          'principal': slotInUse,
          'force-revert-flex': type === 'customer-customer' || type === 'agent-customer',
          'justify-center items-center': chat.is_log_message
        }]" v-if="chat.message" @mouseleave="watchShowModal" @mouseover="insideModal = false"
    >
        <div class="tooltip" v-if="chat.tag_type === 'audio' && chat.type === 0 && chat.ack === -1">
          <span class="tooltip-text">Sua mensagem de áudio não foi enviada</span>
          <button type="button" class="round-button"><p style="font-size: 25px; color: #eee4e4;">!</p></button>
        </div>
        <div style="display: flex; flex-direction: row; align-items: center;" :class="[{'principal': slotInUse}]">
            <div
                style="float: right;"
                class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg max-w-sm"
                :class="{
                  'bg-primary-gradient text-white': (!chat.type) && !chat.is_bot_message,
                  'text-black': type === 'customer-customer' || chat.type === 1 && type === 'agent-customer',
                  'is-bot-message text-white': !chat.type && chat.is_bot_message,
                  'text-white': type === 'agent-customer' && chat.type === 0,
                  'is-comment-message text-white': chat.tag_type === 'comment' && !chat.is_log_message,
                  'is-log-message': chat.is_log_message,
                  'border border-solid border-grey-light bg-white': chat.type
                }"
            >
                <div v-if="chat.message_header" style="white-space: pre-line;" class="mb-2">
                    <div v-if="headerDecode">
                        <div v-if="headerDecode.type === 'image'">
                          <img :src="headerDecode[headerDecode.type].link" style="max-width: 100%;" alt="image from template">
                        </div>
                    </div>
                    <div v-else>
                        <strong class="msg-render">{{ chat.message_header }}</strong>
                    </div>
                </div>

                <div class="zoomable-image" v-if="chat.tag_type === 'image' || chat.tag_type === 'sticker'">
                    <img @click.prevent="$emit('expandImage', chat.message)" :src="chat.message" style="max-width: 100%;" />
                </div>

                <div v-else-if="chat.tag_type === 'contact' && messageDecode !== null">
                    <div class="flex mr-2">
                        <vs-avatar size="large" :src="messageDecode.image"/>
                        <div class="text-center mt-2">
                            <p><b class="ml-3 self-center">{{messageDecode.name}}</b></p>
                            <p class="ml-3 self-center">{{maskedPhone(messageDecode.phone_number)}}</p>
                        </div>
                    </div>

                    <div class="flex w-full" style="justify-content: center" v-if="type !== 'customer-agent' && !hiddenReply && chat.whatsapp_deleted_at == null" >
                        <vs-button
                                type="border"
                                size="small"
                                icon-pack="feather"
                                icon="icon-user-plus"
                                class="mt-2 mb-2 w-5/6"
                                :color=" chat.type === 1 ? 'primary' : 'white'"
                                :class="{'hover:text-dark' : chat.type === 0 }"
                                @click.prevent="dialogAddContact(messageDecode)"
                        >
                            Adicionar Contato
                        </vs-button>
                    </div>
                </div>

                <div v-else-if="chat.tag_type === 'payment' && messageDecode !== null">
                    <div class="is-payment-message rounded">
                        <div class="flex justify-center items-center p-8">
                            <p class="font-bold" :class="type !== 'customer-agent' && !hiddenReply ? 'text-big' : 'text-lg'">
                                {{ maskMoney(messageDecode.amount, messageDecode.currency) }}
                            </p>
                        </div>
                    </div>

                    <div class="flex w-full" style="justify-content: center" v-if="type !== 'customer-agent' && !hiddenReply" >
                        <vs-alert
                                active="true"
                                class="no-message-alert mb-4"
                                :icon="paymentMessage['icon']"
                                :class="`text-${paymentMessage['color']}`"
                                :color="chat.type ? paymentMessage['color'] : 'white'"
                        >
                            <b>{{paymentMessage['type']}}</b> : {{paymentMessage['text']}}
                        </vs-alert>
                    </div>

                    <div style="white-space: pre-line;" v-if="messageDecode.message.type === 'image' || messageDecode.message.type === 'sticker'">
                        <img :src="messageDecode.message.url" :alt="messageDecode.message.body" style="max-width: 100%;" />
                    </div>
                    <div style="white-space: pre-line;" v-else-if="messageDecode.message.type === 'chat'">
                        <div class="msg-render" v-html="stylizeMessage(messageDecode.message.body)"></div>
                    </div>
                </div>

                <div v-else-if="chat.tag_type === 'order'">
                  <div class="flex w-full" style="justify-content: center;" v-if="hasCatalogFeature">
                    <div class="centerx">
                      <vs-alert color="#343a40" style="border-radius: 5px 5px 0 0;">
                        <span style="color: #3F4531; font-size: 11px;"><b>Pedido feito via catálogo</b></span>
                      </vs-alert>
                      <div class="flex w-full" style="justify-content: center;" >
                      <vs-alert 
                        color="#343a40" 
                        style="
                          max-width: 8em !important;
                          max-height: 5.55em !important;
                          border-radius: 0px 0px 0px 5px;
                        "
                      >
                        <img
                          :src="stringToArray(messageDecode.items)[0].thumbnailUrl"
                          alt="" 
                          height="62em" 
                          style="
                            min-width: 5em !important;
                            max-width: 5em !important;
                            height: 4em;
                            border-top-left-radius: 10px;
                            border-bottom-left-radius: 10px;
                            border-top-right-radius: 10px;
                            border-bottom-right-radius: 10px;
                            transform: translateY(-0.8em);
                          "
                        >
                      </vs-alert>
                        <vs-alert
                                active="true"
                                class="no-message-alert mb-4 rounded-alert"
                                color="#343a40"
                                style="
                                  border-radius: 0 0 5px 0;
                                  max-height: 5.55em !important;
                                "
                        >
                            <vs-icon icon="shopping_cart" size="1.1em"></vs-icon>
                            <b>{{messageDecode.itemCount}} 
                              <span v-if="messageDecode.itemCount > 1">itens</span>
                              <span v-else>item</span>
                            </b> <br>
                            <b>Subtotal</b> : {{returnCash(messageDecode.amount)}}
                        </vs-alert>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="msg-render" v-html="stylizeMessage('_⚠️ Você recebeu um pedido via catálogo, porém não possui essa funcionalidade habilitada._')"></div>
                  </div>
                </div>

                <div v-else-if="chat.tag_type === 'location' && messageDecode !== null">
                    <gmap-map
                        :zoom="zoomMap"
                        :center="{
                          lat: messageDecode.lat,
                          lng: messageDecode.lng
                        }"
                        :options="settingsMap"
                        style="width: 24em;  height: 24em;"
                    >
                        <gmap-marker
                            @click="openMap"
                            :optimized="false"
                            :position="{
                              lat: messageDecode.lat,
                              lng: messageDecode.lng
                            }"
                        ></gmap-marker>
                    </gmap-map>

                    <div class="mt-5">
                        <strong><a class="text-black" v-if="messageDecode.place" :href="messageDecode.url" target="_blank">{{messageDecode.place}}</a></strong>
                        <p v-if="messageDecode.address">{{messageDecode.address}}</p>
                        <p v-if="messageDecode.comment">{{messageDecode.comment}}</p>
                    </div>
                </div>

                <div v-else-if="chat.whatsapp_deleted_at != null">
                    <p class='msg_deleted'>{{chat.message}}</p>
                </div>
                
                <div
                    v-else-if="chat.tag_type === 'audio' || chat.tag_type === 'ptt'"
                >
                
                 <div class="play-audio-div">                
                   <div class="p-5 play-audio-btn">
                      <div v-if="chat.ack === -1 && chat.type === 0">
                      <feather-icon v-if="chat.ack === -1 && chat.type === 0 && !hasResentAudio"
                        @click="resendAudioTo()"
                        class="play-audio-icon mr-1 p-2"
                        svgClasses="w-6 h-6 stroke-current"
                        icon="RotateCcwIcon"
                      /></div>
                      <feather-icon v-else
                      @click="sendDataToPlayAudio()"
                      class="play-audio-icon mr-1 p-2"
                      svgClasses="w-6 h-6 stroke-current"
                      icon="PlayIcon"
                      />

                      <feather-icon
                      @click="sendDataToPauseAudio()"
                      class="play-audio-icon p-2"
                      svgClasses="w-6 h-6 stroke-current"
                      icon="PauseIcon"
                      />
                      
                      <input 
                      class="ml-2 mr-2 range-audio-input"
                      type="range"
                      min="0"
                      :max="this.audio ? this.audio.duration() : 0"
                      :value="currentTime"
                      @input="setCurrentTime"
                      >

                      <span class="flex items-center" style="color:black;" @click="isAudioPlaying">
                        <span style="width:32px;">{{ formatedAudioTime(currentTime) }}</span> / 
                        <span>{{ formatedAudioTime(this.audio ? this.audio.duration() : 0) }}</span>
                      </span>

                      <vs-dropdown vs-trigger-click style="cursor:pointer;"> 
                        <vs-icon class="ml-3 p-2 audio-menu" icon="expand_more" style="-webkit-transform: scaleX(-1); transform: scaleX(-1);"></vs-icon>

                        <vs-dropdown-menu style="width:12rem !important;">
                          <vs-dropdown-item @click="downloadAudio" @touchstart.prevent="downloadAudio" style="padding-right: 1.8rem !important;">
                            <feather-icon
                            class="pr-2"
                            icon="DownloadIcon"
                            svgClasses="w-4 h-4 stroke-current"                          
                            /> Baixar
                          </vs-dropdown-item>

                          <vs-dropdown-item @click="openAudioNewWindow" @touchstart.prevent="openAudioNewWindow">
                            <feather-icon
                            class="pr-2"
                            icon="ExternalLinkIcon"
                            svgClasses="w-4 h-4 stroke-current"                          
                            /> Nova guia
                          </vs-dropdown-item>
                        </vs-dropdown-menu>
                      </vs-dropdown>

                   </div>
                 </div>

                </div>

                <div v-else-if="chat.tag_type === 'video'">
                    <video width="100%" height="240" controls>
                        <source
                            :src="chat.message"
                            type="video/mp4"
                        >
                    </video>
                </div>

                <div
                    v-else-if="
                      chat.tag_type === 'document'
                      || chat.tag_type === 'doc'
                      || chat.tag_type === 'pdf'
                    "
                    @click="downloadDocument(chat.message, chat.document_name, chat.document_mimetype)"
                    style="cursor: pointer;"
                >
                    <strong>{{ chat.document_name }}</strong>
                    <div class="flex mt-2 mb-2">
                        <feather-icon icon="DownloadIcon" />
                        <span class="ml-3 self-center"> Baixar documento</span>
                    </div>
                </div>

                <div v-else-if="chat.tag_type && ['protocol', 'fanout', 'ciphertext'].includes(chat.tag_type)" style="white-space: pre-line; color: #a9a9a9;"  >
                    <div class="msg-render" v-html="stylizeMessage('_' + chat.message + '_')"></div>
                </div>

                <div v-else style="white-space: pre-line;" >
                    <div
                      class="msg-render" 
                      v-html="stylizeMessage(chat.message)"
                    />
                </div>

                <div v-if="chat.message_footer" style="white-space: pre-line;">
                    <small class="msg-render">{{ chat.message_footer }}</small>
                </div>

                <div v-if="chat.message_buttons && buttonsDecode.length" class="w-full buttons select-none">
                  <div v-for="(item, index) in buttonsDecode.slice(0, 3)" :key="index">
                    <vs-chip v-if="index === 2 && buttonsDecode.length > 3"> <vs-icon icon="menu" size="small"/> Veja mais opções </vs-chip>

                    <vs-chip v-else-if="item.url" >
                      <div @click="redirectTo(item.url)">
                        <feather-icon svgClasses="w-4 h-4" class="mr-1" icon="ExternalLinkIcon"/>
                        {{ item.text }}
                      </div>
                    </vs-chip>

                    <vs-chip v-else>{{ item.text }}</vs-chip>
                  </div>
                </div>

                <div
                    style="white-space: normal;"
                    v-if="chat.caption"
                >
                    {{ chat.caption.trim()}}
                </div>
                <div class="chat-footer" align="right" v-if="!chat.is_log_message">
                    <small v-if='chat.whatsapp_deleted_at != null'>
                        Mensagem deletada: {{sentAtMessageDateTime(chat.whatsapp_deleted_at)}}
                    </small>
                    <small v-else-if='chat.is_edited'>
                        Editada {{sentAtMessage(chat.sent_at)}}
                    </small>
                    <small v-else>
                        {{ chat.is_temp ? 'Enviando...' : sentAtMessage(chat.sent_at) }}
                    </small>
                    <div class="chat-ack-container" v-if="!chat.type">
                        <i :class="'chat-ack-icon material-icons ' + iconColor(chat)">
                            {{ icon(chat) }}
                        </i>
                    </div>
                </div>
                <div v-if="!hiddenReply && !chat.is_temp && chat.whatsapp_deleted_at == null && chat.tag_type !== 'comment' && !chat.message.includes('Foi mencionada uma imagem/documento/video antigo, não existe no histórico do seu dispositivo')">
                  <VsDropdown ref="reaction-component" vs-collapse  style="cursor: pointer" class="reaction-message-menu" :class="{'message-menu-send' : !chat.type, 'message-menu-received' : chat.type}" @mouseenter="insideModal = true" :placement="'bottom'" :appendToBody="true">
                    <vs-icon icon="mood" title="Reagir"></vs-icon>
                    <VsDropdownMenu v-if="showModal">
                      <div>
                        <picker
                          title=""
                          set="apple"
                          color="#42acff"
                          emoji="raised_hand"
                          locale="br"
                          :perLine="11"
                          @select="selectEmoji"
                          :infiniteScroll=false
                          :style="{ width: '30em', height: '20em' }"
                          style="cursor: pointer;"
                        />
                      </div>
                    </VsDropdownMenu>
                  </VsDropdown>
                </div>

                <div v-if="chat.reactions && chat.reactions.length > 0" >
                  <vs-dropdown vs-collapse  vs-trigger-click class="reaction-message-viewer" :class="{'message-viewer-send' : !chat.type, 'message-viewer-received' : chat.type}">
                    <vs-chip color="write">
                      <span v-for="(reaction, key) in chat.reactions" :key="key + 'chip'" class="m-1">
                        {{reaction.reaction_text}}
                      </span>
                    </vs-chip>

                    <vs-dropdown-menu>
                      <vs-dropdown-item class="cursor-pointer" v-for="(reaction, key)  in chat.reactions" :key="key + 'item'">
                        <vs-list v-if="!reaction.type">
                          <div @click="selectEmoji({data: ''}, 'remove')">
                            <vs-list-item :title="'Você'" :subtitle="reaction.ack !== -1 ? 'Clique para remover' : 'Não foi possível enviar'">
                              <template slot="avatar"><vs-avatar :src=activeUserImg /></template>
                              <span>{{reaction.reaction_text}}</span>
                            </vs-list-item>
                          </div>
                        </vs-list>

                        <vs-list v-else>
                          <vs-list-item :title="contactName">
                            <template slot="avatar"><vs-avatar :src=contactImage /></template>
                            <span>{{reaction.reaction_text}}</span>
                          </vs-list-item>
                        </vs-list>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>

                <div @mouseleave="stateDropDown" v-if="chat.type && type !== 'customer-agent' && !hiddenReply && chat.whatsapp_deleted_at == null && chat.tag_type !== 'comment' && !chat.message.includes('Foi mencionada uma imagem/documento/video antigo, não existe no histórico do seu dispositivo')">
                  <vs-icon title="Opções" icon-pack="feather" class="reply-message" icon="icon-arrow-right" @click="toggleDropdown()"></vs-icon>

                  <div v-if="showDropdown" @mouseover="closeOptionDropdown" class="dropdown-content" style="transform: translateX(100%)" :style="{'top':`${top}em`}">
                    <div class="m-3 ml-10 mb-3 cursor-pointer">
                      <p @click="reply(chat)">Responder</p>
                    </div>

                    <div v-if="chat.tag_type !== 'location'" class="m-3 ml-10 mb-3 cursor-pointer">
                      <p @click="forward(chat)">Encaminhar</p>
                    </div>
                  </div>
                </div>

                <div @mouseleave="stateDropDown" v-if="(!chat.type && type !== 'agent-agent' || !chat.type && principalIndex) && !hiddenReply && chat.tag_type !== 'comment' && !chat.message.includes('Foi mencionada uma imagem/documento/video antigo, não existe no histórico do seu dispositivo')">
                  <vs-icon title="Opções" icon-pack="feather" class="reply-message" icon="icon-arrow-right" @click="toggleDropdown()"></vs-icon>

                  <div v-if="showDropdown" class="dropdown-content-left" :style="{'top':`${top}em`}" @mouseover="closeOptionDropdown">
                    <div class="m-3 ml-10 mb-3 cursor-pointer">
                      <p @click="reply(chat)">Responder</p>
                    </div>
                    <div v-if="chat.tag_type !== 'location'" class="m-3 ml-10 mb-3 cursor-pointer">
                      <p @click="forward(chat)">Encaminhar</p>
                    </div>
                  </div>
                </div>

                <div v-if="hasCatalogFeature && chat.tag_type === 'order'">
                  <vs-button @click.prevent="active=!active" @click="getOrderByMsg(chat)" style=" width: 100%; height: 1em" line-position="top" line-origin="center" color="#343a40" type="line"> <b>{{type === 'customer-agent' ? 'Mostrar detalhes' : 'Mostrar pedido'}}</b></vs-button>
                </div>

                <slot></slot>
            </div>
            <div style="clear: both;"></div>
        </div>
    </div>
</template>

<script>

import axios from 'axios'
import { maskPhoneNumber,  stylizeMessage,  maskMoney,  paymentTypes,  getTimeZone,  hasFeature,  redirectTo } from '@/utils'
import orderByMsg from '@/http/requests/catalog/index.js'
import VsDropdown from "@/components/vs-dropdown/dropdown.vue";
import VsDropdownMenu from "@/components/vs-dropdown/dropdown-menu.vue";
import VsDropdownItem from "@/components/vs-dropdown/dropdown-item.vue";
import {Howl, Howler} from 'howler';
import { Picker } from 'emoji-mart-vue'

export default{
  name: 'ChatLogItem',
  data() {
    return {
      zoomMap: 17,
      active: false,
      orders: [],
      top: 0,
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTE1BFq0h-RvrEBWCMPudD2QMYcG2BDJVDYNw&usqp=CAU',
      redirectUrl: 'https://www.google.com.br/maps/place/',
      settingsMap: {
        zoomControl: true,
        scaleControl: false,
        rotateControl: false,
        mapTypeControl: false,
        disableDefaultUi: false,
        streetViewControl: false,
        fullscreenControl: false,
      },
      audio: null,
      currentTime: 0,
      showModal: true,
      intervalId: null,
      resendAudio: false,
      hasResentAudio: false,
      hasCatalogFeature: false,
      insideModal: false,
      lastScrollTop: 0,
      showDropdown: false,
      stateDropDownLeave: true
    };
  },
  components: {
    VsDropdown,
    VsDropdownMenu,
    VsDropdownItem,
    Picker,
    Howler,
    Howl
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    instanceId: {
      type: Number,
      required: true,
    },
    type: {
      default: null,
      type: String
    },
    chat: {
      default: null,
      type: Object
    },
    hiddenReply: {
      type: Boolean,
      default: false
    },
    principalIndex: {
      type: Number,
      default: null
    },
    audioMap: {
      type: Object,
      required: false,
      default: null
    },
    contactImage:{
      type: String,
      default: null,
      required: false
    },
    contactName:{
      type: String,
      default: null,
      required: false
    }
  },
  computed: {
    slotInUse() {
      return this.$slots.default
    },
    messageDecode() {
      return this.decodeJson(this.chat.message);
    },
    headerDecode(){
      return this.decodeJson(this.chat.message_header);
    },
    buttonsDecode(){
      return this.decodeJson(this.chat.message_buttons);
    },
    paymentMessage() {
      try { return this.paymentTypes(this.messageDecode) }
      catch (error) { return null }
    },
    activeUserImg() {
      return this.$store.state.AppActiveUser.image;
    }
  },
  methods: {
    redirectTo,
    maskMoney,
    paymentTypes,
    stylizeMessage,
    icon (chat) {
      if (chat.is_temp) {
        return 'schedule'
      }

      if (chat.ack === -7) { // MD_DOWNGRADE = -7
        return 'report_problem'
      }
      if (chat.ack === -6) { // INACTIVE = -6
        return 'report_problem'
      }
      if (chat.ack === -5) { // CONTENT_UNUPLOADABLE = -7
        return 'report_problem'
      }
      if (chat.ack === -4) { // CONTENT_TOO_BIG = -7
        return 'report_problem'
      }
      if (chat.ack === -3) { // CONTENT_GONE = -7
        return 'report_problem'
      }
      if (chat.ack === -2) { // EXPIRED = -7
        return 'report_problem'
      }
      if (chat.ack === -1) { // FAILED = -7
        return 'report_problem'
      }
      if (chat.ack === 0) { // CLOCK = 0
        return 'schedule'
      }
      if (chat.ack === 1) { // SENT = 1
        return 'done'
      }
      if (chat.ack === 2) { // RECEIVED = 2
        return 'done_all'
      }
      if (chat.ack === 3) { // READ = 3
        return 'done_all'
      }
      if (chat.ack === 4) { // PLAYED = 4
        return 'done_all'
      }

      if (chat.sent_at) {
        return 'check'
      }

      return '';
    },
    getOrderByMsg(chat) {
      const fetchProducts = orderByMsg.getOrderByMsg(chat.id, chat.instance_id);
      fetchProducts.then((response) => {
        this.$events.fire('GetOrderByMsg', response.data.data.getOrderByMsg, this.messageDecode, chat);
      })
    },
    watchShowModal() {
      if (!this.insideModal) {
        this.showModal = false;
  
        setTimeout(() => {
          this.showModal = true;
        }, 10);

      }
    },
    stringToArray(data) {
      return JSON.parse(data);
    },
    closeOptionDropdown() {
      this.$events.off('closeOptionDropdown')
      this.$events.on('closeOptionDropdown', data => {
        this.stateDropDownLeave = data
      })
    },
    stateDropDown() {
      if (!this.stateDropDownLeave) {
        this.showDropdown = false
      }
    },
    iconColor (chat) {
      if (chat.ack === 3) { // READ = 3
        return 'chat-ack-icon-blue'
      }
      if (chat.ack === 4) { // PLAYED = 4
        return 'chat-ack-icon-blue'
      }

      return 'chat-ack-icon-gray';
    },
    calculateOneMinute() {
      let timestamp = this.chat.sent_at;
      const timestampDate = new Date(timestamp);
      timestampDate.setMinutes(timestampDate.getMinutes() + 1);

      const now = new Date();
      const hasPassedOneMinute = now >= timestampDate;

      return hasPassedOneMinute;
    },
    reply(customerChat) {
      this.showDropdown = false;
      this.$store.dispatch('chat/setReplyMessage', customerChat);
    },
    forward(customerChat) {
      this.showDropdown = false;
      
      let data = {
        showPopup: true,
        customer_chat: customerChat
      }

      this.$events.emit('ForwardChat', data);
    },
    returnCash(value) {
      return (value / 1000).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    decodeJson(message) {
      try { return JSON.parse(message) }
      catch (error) { return null }
    },
    handleScroll() {
      
      this.showModal = this.$parent.$el.scrollTop === this.lastScrollTop ? true : false;
      
      setTimeout(() => {
          this.showModal = true;
      })

      this.lastScrollTop = this.$parent.$el.scrollTop;
    },
    sentAtMessage(sentAt) {
      if (!sentAt) {
        return ''
      }
      return getTimeZone(sentAt)
    },
    sentAtMessageDateTime(sentAt) {
      return getTimeZone(sentAt) 
    },
    downloadDocument(url, documentName, documentMimetype) {
      axios.get(url, {
        responseType: 'blob'
      }).then(res => {
        var blob = new Blob(
          [res.data],
          { type: `${documentMimetype};charset=utf-8;` }
        )

        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = documentName
        link.click()
        window.URL.revokeObjectURL(link.href)
      })
    },
    openMap(){
      let url = this.redirectUrl + this.messageDecode.lat + ',' + this.messageDecode.lng;
      window.open(url, '_blank');
    },
    maskedPhone(phone) {
      return maskPhoneNumber(phone);
    },
    getExtension(text) {
      const split = text.split('.')
      return split[split.length - 1]
    },
    openAudioNewWindow() {
      window.open(this.chat.message, '_blank')
    },
    downloadAudio() {
      this.$vs.notify({
        title: 'Download Iniciado',
        text: 'O audio já será baixado!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
      fetch(this.chat.message)
        .then(response => response.blob())
        .then(blob => {
          const urlBlob = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = urlBlob;
          link.download = 'audio' + Date.now() + '.mp3'
          link.click();
          window.URL.revokeObjectURL(urlBlob);
        });
    },
    dialogAddContact(contact) {
      contact.is_favorite = 0
      contact.open_field = null
      contact.is_blacklisted = 0

      this.$vs.dialog({
        type:'confirm',
        color: 'primary',
        title: `Atenção!`,
        text: 'Deseja adicionar esse contato?',
        accept: () => { this.$emit('on-add-customer', contact) },
        acceptText: 'Sim',
        cancelText: 'Voltar',
      })
    },
    sendDataToPlayAudio() {
      this.$emit('sendDataToPlayAudio', this.chat.message)
      this.showAdudioCurrentTime()
    },
    sendDataToPauseAudio() {
      this.$emit('sendDataToStopAudio', this.chat.message)
      clearInterval(this.intervalId);
    },
    resendAudioTo(){
      if (!this.hasResentAudio) {
        this.hasResentAudio = true;
        this.$emit('resendAudio', this.chat);
      }
    },
    showAdudioCurrentTime() {
      this.intervalId = setInterval(() => {
        this.isAudioPlaying();
      }, 1000);
    },
    totalAudioTime() {
      this.audio = new Howl({
        src: [this.chat.message],
        format: ['mp3', 'ogg', 'wav'],
      });
    },
    formatedAudioTime(duration) {
      let minutes = Math.floor(duration / 60);
      let seconds = Math.floor(duration % 60);
      
      return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
    },
    isAudioPlaying() {
      this.currentTime = this.audioMap[this.chat.message] ? this.audioMap[this.chat.message].seek() : 0;
    },
    setCurrentTime(event) {
      if (this.audioMap[this.chat.message].playing()) {
        this.audioMap[this.chat.message].seek(event.target.value);
      }
    },
    selectEmoji(emoji, status) {
      this.$store.dispatch("chatContact/sendReactionToMessage", {
        reaction          : status === 'remove' ? emoji.data : emoji.native,
        customerChatId    : this.chat.id,
        instanceId        : this.instanceId,
      }).then(() => {
        this.$vs.notify({
          color: 'success',
          title: 'Reação enviada!'
        });

        this.showModal = false;
        
        setTimeout(() => {
          this.showModal = true;
        }, 30);
      }).catch((error) => {
        console.error('error', error)
      })
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
  },

  updated() {
    if (this.chat.tag_type === 'audio' || this.chat.tag_type === 'ptt') {
      this.showAdudioCurrentTime();
    }
  },
  async mounted() {
    this.$parent.$el.addEventListener('scroll', this.handleScroll);

    if (this.chat.tag_type === 'audio' || this.chat.tag_type === 'ptt') {
      this.totalAudioTime()
    }

    if (this.chat.tag_type === 'order'){
      this.hasCatalogFeature = await hasFeature('catalog');
    }

  },
  destroyed() {
    this.$parent.$el.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style>
  .rounded-alert {
    border-radius: 0px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
    .zoomable-image {
    position: relative;
    display: inline-block;
    overflow: hidden;
  }
  
  .zoomable-image img {
    display: block;
    width: 100%;
    height: auto;
  }
  
  .zoomable-image:hover {
    cursor: zoom-in;
  }
</style>

<style lang="scss">
.chat-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.chat-ack-icon-gray {
  color: #c4c4c4;
}

.chat-ack-icon-blue {
  color: #44ffff;
}

.chat-ack-container {
  display: inline-block;

  .chat-ack-icon {
    font-size: 13px;
    margin-left: 5px;
  }
}

.is-bot-message {
  background: linear-gradient(118deg, rgba(0, 208, 227, 1), rgba(0, 208, 227, 0.7)) !important;
}

.is-comment-message {
  background: linear-gradient(118deg, rgb(255,159,67), rgba(255,159,67, 0.7)) !important;
}

.is-log-message {
  background: linear-gradient(118deg, rgba(28, 54, 204, 0.795), rgba(66, 92, 241, 0.774)) !important;
  text-align: center !important;
  font-style: italic;
  font-weight: 450;
}

.is-payment-message {
    background-image: url("~@/assets/images/elements/payment-cover.png");
    background-position: 50% 50%;
    background-size: cover;
}

.text-black {
  color: #6B7589 !important;
}

.force-revert-flex{
  flex-direction: row !important;
}

.force-revert-revert-flex {
  flex-direction: row-reverse !important;
}

.recovery {
  background: #d5e2f2;
  color: #11749c;
  font-size: 0.9em;
}

.chat-message {
  white-space: pre-line;
  code {
    background-color: transparent;
  }
  del {
    text-decoration: line-through;
    text-decoration-thickness: 1px;
  }
}

.container-emoji{
  height: 10vw;
  max-height: 10vw;
  background-color: white;
  font-family: "Montserrat", Helvetica, Arial, sans-serif;
}

.reaction-message-menu {
  top: calc(50% - 1vh) !important;
  background: rgba(73, 70, 70, 0.39);
  position: absolute !important;
  border-radius: 50% !important;
  text-align: center !important;
  border: 0 solid !important;
  font-size: 20px !important;
  height: 28px !important;
  width: 28px !important;
  vertical-align: middle;
  line-height: revert;
  cursor: pointer;
  display: none;
  color: #ffff;

  i { margin-top: 0.2vh; }
}
.message-menu-send{ right: 108% !important; }
.message-menu-received{ left: 108% !important; }

.reaction-message-viewer {
  z-index: 1;
  max-height: 15vw;
  position: absolute !important;

  .vs-dropdown--item-link {
    &:hover {
      background: #0b0b0b!important;
    }
  }
}
.message-viewer-send{ right: 0.5vw !important; }
.message-viewer-received{ left: 0.5vw !important; }

.reply-message {
  position: absolute !important;
  top: -3px;
  right: -8px;
  background: #89c5ed;
  color: #ffff;
  border-radius: 24px !important;
  border: 0px solid;
  width: 20px !important;
  height: 20px;
  text-align: center !important;
  font-size: 14px !important;
  vertical-align: middle;
  line-height: revert;
  cursor: pointer;
}

.msg_deleted {
  text-decoration: line-through
}

.play-audio-div {  
  .play-audio-btn {
    display: flex;
    align-items: center;
    border: 2px solid #0491ff;
    border-radius: 14px;
    background-color: white;
    .con-vs-slider{
      min-width:130px;
      margin-left: 1.5rem;
      margin-right: 1rem;
    }
  }
  .play-audio-icon {
    cursor: pointer;
    border-radius: 5px;
    background-color:#0491ff;
    svg{
      color:white;
    }
  }
}

.audio-menu {
  color:white;
  border-radius:5px;
  background-color: #0491ff;
}

.temp-message {
  background-color: #0000001f;
  border-radius: 10px;
  padding: 1em;
  font-weight: 600;
  border: 1px solid #00000073;
}

.buttons {
  padding: 0.5vw;
  margin-top: 1vw;
  border-radius: 1vw;
  display: inline-grid;
  justify-content: center;

  .vs-icon{
    font-size: 0.7rem;
    padding-top: 0.5rem;;
  }

  .con-vs-chip {
    cursor: pointer;
    width: 100% !important;
    &:hover{
      background-color: rgba(var(--vs-primary), 0.5) !important;
    }
  }
}

.scrollable-content {
  max-height: 100%;
  overflow-y: auto;
}

.sidebar-item {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999999;
}

@media (max-width:400px) {
  .range-audio-input {
    width: 4em;
  }
}

@media (max-width:350px) {
  .range-audio-input {
    display:none;
  }
}

.round-button {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #ea5455;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 20px;
    margin-top: 45px;
    border: none;
    box-shadow: 0 0 0 3px #eee4e4;
}

.tooltip {
    position: relative;
    display: inline-block;
}

.tooltip-text {
      visibility: hidden;
      width: 350px;
      background-color: #333;
      color: #fff;
      text-align: center;
      border-radius: 8px;
      padding: 5px;
      position: absolute;
      z-index: 1;
      top: 80%;
      left: -340px;
      transform: translateY(-50%);
      opacity: 0;
      transition: opacity 0.3s;
      font-weight: bold;
}
.tooltip-text::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 100%;
  margin-top: -8px;
  border-width: 8px;
  border-style: solid;
  border-color: transparent transparent transparent #333;
}


.tooltip:hover .tooltip-text {
      visibility: visible;
      opacity: 1;
}

.dropdown-content {
  position: absolute;
  color: #757477;
  right: 0;
  margin-left: 2em;
  background-color: #ffffff;
  min-width: 12em;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  text-align: left;
  border-radius: 5px;
}

.dropdown-content-left {
  position: absolute;
  color: #757477;
  right: 0;
  background-color: #ffffff;
  min-width: 12em;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  text-align: left;
  border-radius: 5px;
}

</style>
